(function() {
    angular
        .module("globalSearchModule")
        .controller("GlobalSearchDevicesController", GlobalSearchDevicesController)

        GlobalSearchDevicesController.$inject = [
        "$rootScope",
        "$scope",
        "devicesService",
        "userMessagingService"
    ]

    function GlobalSearchDevicesController(
        $rootScope,
        $scope,
        devicesService,
        userMessagingService
    ){
        "use strict"

        $rootScope.title = "Devices Search | WANCO"

        $scope.page           = 1
        $scope.perPage        = 10
        $scope.results        = undefined
        $scope.totalAvailable = 0
        $scope.searchData     = ""
        $scope.isSearching    = false

        $scope.search = function(typedSearchData) {

            if (typedSearchData || typedSearchData === "") {

                if ($scope.searchData === typedSearchData) {
                    return
                }

                $scope.page = 1

                $scope.searchData = typedSearchData

            }

            $scope.results        = undefined
            $scope.totalAvailable = 0
            getPageCount()

            if ($scope.searchData && $scope.searchData !== "") {

                const success = (data, totalAvailable) => {
                    gtag("event", "search", { category: "DEVICES", search_term: $scope.searchData, target_customer: null })

                    $scope.isSearching = false
                    $scope.results = data
                    $scope.totalAvailable = totalAvailable
                    getPageCount()

                }

                const failure = (error) => {

                    $scope.isSearching = false
                    userMessagingService.error(error)

                }

                $scope.isSearching = true

                devicesService.searchDevices($scope.searchData, $scope.page, $scope.perPage, 300, success, failure)

            }
        }

        $scope.changePerPage = function(perPage) {

            $scope.perPage = perPage
            $scope.page = 1
            getPageCount()
            $scope.search()

        }

        $scope.changePage = function(page) {

            const newPage = $scope.page + page

            if(newPage < 1 || newPage > $scope.maxPages) {
                return
            }

            $scope.page = newPage
            $scope.search()

        }

        const getPageCount = function() {
            $scope.maxPages = Math.ceil($scope.totalAvailable / $scope.perPage)
        }
    }
})()
